module.exports = __webpack_public_path__ + "static/media/alarm-2.4d99bcdb.mp3";